import { useEffect, useState, FunctionComponent } from 'react'

import Skeleton from '@mui/material/Skeleton'
import { range } from 'libraries/lodash'

import { QAccordionSkeletonContainerProps } from 'redux/containers/components/accordion/QaAccordionSkeletonContainer'

const QaAccordionSkeleton: FunctionComponent<QAccordionSkeletonContainerProps> = ({ windowHeight, headerHeight, flavour, ...props }) => (
  <div
    className='w-100 overflow-y-auto bg-page-background flex justify-center scrolling-container flex-wrap'
    style={{ maxHeight: `${windowHeight - headerHeight}px` }}
  >
    <div className='grow-1 shrink-1 basis0 ph0 ma0'>
      <div className='content-view'>
        <div className='layout-width-constraint'>
          <div className='bg-page-background pb8 mb6'>
            <AccordionTitle {...{ ...props, flavour }} />
            <div className='bg-white pb8 mb6'>
              <ul className='group cd-accordion-menu'>
                {range(0, 8).map((_, index) => (
                  <GroupHeader key={index} {...{ flavour }} />
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

const AccordionTitle: FunctionComponent<Pick<QAccordionSkeletonContainerProps, 'sectionId' | 'flavour' | 'sectionsMap'>> = ({ sectionId, sectionsMap }) => {
  const [sectionTitle, setSectionTitle] = useState<string>()

  useEffect(() => {
    if (sectionId !== null && sectionId !== '' && sectionsMap !== null && sectionsMap.has(sectionId)) {
      const entry = sectionsMap.get(sectionId)
      if (entry !== undefined) setSectionTitle(entry.title)
    }
  }, [sectionId, sectionsMap])

  return (
    <div className='ma0 pl6 pt7 pb6 bg-white db w-100 bb-thick b--suez-canal'>
      {sectionTitle !== undefined && sectionTitle !== ''
        ? <span className='b f3 fw7'>{sectionTitle}</span>
        : (
          <span className='o-60'>
            <Skeleton classes={{ root: 'w14 bg-grey', text: 'f3 fw7' }} />
          </span>
          )}
    </div>
  )
}

const GroupHeader: FunctionComponent<Pick<QAccordionSkeletonContainerProps, 'flavour'>> = () => (
  <li className='mb0'>
    <div
      className='w-100 f5 b ma0 pv0 ph6 min-h3 shadow-none flex items-center bb bg-white group b--eastern-breeze'
    >
      <div className='flex items-center justify-center justify-between h-100 w-100'>
        <div className='o-60'>
          <Skeleton variant='text' classes={{ root: 'w14 bg-grey', text: 'f5 fw7' }} />
        </div>
        <div className='flex items-center justify-center'>
          <div className='o-60 ml5'>
            <Skeleton variant='circular' classes={{ root: 'bg-grey' }} width={24} height={24} />
          </div>
        </div>
      </div>
    </div>
  </li>
)

export default QaAccordionSkeleton
